import { useBlendingVoiceSelect } from "@/components/common/voice-selector/hooks/use-blending-voice-select";
import { VoiceModel } from "@/actions/db/get-models";
import VoiceSelectorBase from "@/components/common/voice-selector/selectors/base/voice-selector-base";
import VoiceBlendingTopBar from "@/components/common/voice-selector/top-bars/voice-blending-top-bar";

type BlendingVoiceSelectorProps = {
  otherVoice?: VoiceModel;
  handleVoiceModelClick: (voice: VoiceModel) => void;
};

const BlendingVoiceSelector = ({
  otherVoice,
  handleVoiceModelClick,
}: BlendingVoiceSelectorProps) => {
  const {
    isLoading,
    searchValue,
    filteredVoiceList,
    handleFilterSelect,
    handleGenderSelect,
    handleSearch,
    scrollY,
    scrollUpdate,
    hasSearched,
    compatibilityCategories,
    setSelectedCompatibilityCategory,
    isCompatible,
    isCategorySelected,
  } = useBlendingVoiceSelect(otherVoice);

  return (
    <VoiceSelectorBase
      isLoading={isLoading}
      filteredVoiceList={filteredVoiceList}
      handleVoiceModelClick={handleVoiceModelClick}
      scrollUpdate={scrollUpdate}
      hasSearched={hasSearched}
      searchValue={searchValue}
    >
      <VoiceBlendingTopBar
        handleGenderSelect={handleGenderSelect}
        handleFilterSelect={handleFilterSelect}
        handleSearch={handleSearch}
        scrollY={scrollY}
        isCompatible={isCompatible()}
        compatibilityCategories={compatibilityCategories}
        isCategorySelected={isCategorySelected}
        handleCategoryClick={setSelectedCompatibilityCategory}
      />
    </VoiceSelectorBase>
  );
};

export default BlendingVoiceSelector;
